import config from './isomorphic-config';
export default config;
